import { useRef } from "react";
import ModalBase, { IModalBaseProps, ModalBaseRefType } from "../../../Base/ModalBase";
import { PropertySafetyOutlined } from "@ant-design/icons";
import TituloVisualizarScreen from "./TituloVisualizarScreen";

export interface TituloVisualizarModal extends IModalBaseProps {
    codigo:number;
}
export default function TituloVisualizarModal({
    codigo,
    width,
    textButtonOpen,
    propsButtonOpen,
    footer,
    ...props
}:TituloVisualizarModal) {
    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.style = propsButtonOpen.style ?? {};

    const refModal = useRef<ModalBaseRefType|null>(null);

    return <ModalBase
        {...props}
        ref={refModal}
        title={textButtonOpen ?? "Informações do titulo"}
        width={width ?? "85vw"}
        textButtonOpen={textButtonOpen ?? "Ver"}
        destroyOnClose={true}
        propsButtonOpen={{
            ...propsButtonOpen,
            type : propsButtonOpen.type ?? "dashed",
            size : propsButtonOpen.size ?? "small",
            style : {
                ...propsButtonOpen.style,
                width : propsButtonOpen.style.width ?? "min-content"
            }
        }}
        footer={footer ?? <></>}
    >
        <TituloVisualizarScreen codigo={codigo} onClose={() => refModal.current?.fechar()} />
    </ModalBase>; 
}